import { render, staticRenderFns } from "./account-agent.vue?vue&type=template&id=0c6be7f6"
import script from "./account-agent.vue?vue&type=script&lang=js"
export * from "./account-agent.vue?vue&type=script&lang=js"
import style0 from "./account-agent.vue?vue&type=style&index=0&id=0c6be7f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports